SockJS = require 'public/bower_components/sockjs-client/dist/sockjs'

class exports.Socket

    messageHandlers:

        # Global messages to everyone

        # Site was updated - please refresh
        reload:
            [
                (data) ->
                    $('#reload-site').show()
            ]

        # File conversion complete
        conversionComplete:
            [
                (data) ->
                    $('#conv-confirm').toggle('slide') if $('#conv-confirm').is(':visible')
                    $('#conv-complete').toggle('slide')
            ]


        # File conversion needs attention
        conversionConfirm:
            [
                (data) ->
                    $('#conv-complete').toggle('slide') if $('#conv-complete').is(':visible')
                    $('#conv-confirm').toggle('slide')
            ]

        confirmationStatusUpdate:
            [
                (data) ->
                    window.confirmationStatusUpdate?(data)
            ]

        conversionRequestSent:
            [
                (data) ->
                    window.conversionRequestSent?(data)
            ]

        inputFileUploading:
            [
                (data) ->
                    window.inputFileUploading?(data)
            ]

        inputFileProcessed:
            [
                (data) ->
                    window.inputFileProcessed?(data)
            ]

        vpsCount:
            [
                (data) ->
                    window.confirmation?(data)
            ]

        # Converstion status update
        vpsStatusUpdate:
            [
                (data) ->
                    window.socketUpdateVps?(data)
            ]

        # Data package is being prepared
        dataPackagePending:
            [
                (data) ->
                    $('#download-pending').toggle('slide') if not $('#download-pending').is(':visible')
                    window.downloadPreparing?(true)
            ]

        # Data package is ready to download
        dataPackageReady:
            [
                (data) ->
                    $('#download-pending').toggle('slide') if $('#download-pending').is(':visible')
                    $('#download-complete').toggle('slide') if not $('#download-complete').is(':visible')
                    window.downloadPreparing?(false)
            ]

        fieldViewImportingSyncData:
            [
                (data) ->
                    $('#fieldview-pending').toggle('slide') if $('#fieldview-pending').is(':visible')
                    $('#fieldview-importing').toggle('slide') if not $('#fieldview-importing').is(':visible')
            ]

        fieldViewNewSyncData:
            [
                (data) ->
                    $('#fieldview-importing').toggle('slide') if $('#fieldview-importing').is(':visible')
                    $('#fieldview-pending').toggle('slide') if not $('#fieldview-pending').is(':visible')
            ]

        johnDeereImportingSyncData:
            [
                (data) ->
                    $('#johndeere-pending').toggle('slide') if $('#johndeere-pending').is(':visible')
                    $('#johndeere-importing').toggle('slide') if not $('#johndeere-importing').is(':visible')
            ]

        johnDeereImportingSyncDataYield:
            [
                (data) ->
                    $('#johndeere-pending-yield').toggle('slide') if $('#johndeere-pending-yield').is(':visible')
                    $('#johndeere-importing-yield').toggle('slide') if not $('#johndeere-importing-yield').is(':visible')
            ]

        johnDeereImportingSyncDataApplication:
            [
                (data) ->
                    $('#johndeere-pending-application').toggle('slide') if $('#johndeere-pending-application').is(':visible')
                    $('#johndeere-importing-application').toggle('slide') if not $('#johndeere-importing-application').is(':visible')
            ]

        johnDeereImportingSyncDataPlanting:
            [
                (data) ->
                    $('#johndeere-pending-planting').toggle('slide') if $('#johndeere-pending-planting').is(':visible')
                    $('#johndeere-importing-planting').toggle('slide') if not $('#johndeere-importing-planting').is(':visible')
            ]

        fieldViewImportingSyncDataYield:
            [
                (data) ->
                    $('#fieldview-pending-yield').toggle('slide') if $('#fieldview-pending-yield').is(':visible')
                    $('#fieldview-importing-yield').toggle('slide') if not $('#fieldview-importing-yield').is(':visible')
            ]

        fieldViewImportingSyncDataApplication:
            [
                (data) ->
                    $('#fieldview-pending-application').toggle('slide') if $('#fieldview-pending-application').is(':visible')
                    $('#fieldview-importing-application').toggle('slide') if not $('#fieldview-importing-application').is(':visible')
            ]

        fieldViewImportingSyncDataPlanting:
            [
                (data) ->
                    $('#fieldview-pending-planting').toggle('slide') if $('#fieldview-pending-planting').is(':visible')
                    $('#fieldview-importing-planting').toggle('slide') if not $('#fieldview-importing-planting').is(':visible')
            ]

        fieldViewNewSyncDataYield:
            [
                (data) ->
                    $('#fieldview-importing-yield').toggle('slide') if $('#fieldview-importing-yield').is(':visible')
                    $('#fieldview-pending-yield').toggle('slide') if not $('#fieldview-pending-yield').is(':visible')
            ]
        fieldViewNewSyncDataApplication:
            [
                (data) ->
                    $('#fieldview-importing-application').toggle('slide') if $('#fieldview-importing-application').is(':visible')
                    $('#fieldview-pending-application').toggle('slide') if not $('#fieldview-pending-application').is(':visible')
            ]


        fieldViewNewSyncDataPlanting:
            [
                (data) ->
                    $('#fieldview-importing-planting').toggle('slide') if $('#fieldview-importing-planting').is(':visible')
                    $('#fieldview-pending-planting').toggle('slide') if not $('#fieldview-pending-planting').is(':visible')
            ]

        johnDeereNewSyncData:
            [
                (data) ->
                    $('#johndeere-importing').toggle('slide') if $('#johndeere-importing').is(':visible')
                    $('#johndeere-pending').toggle('slide') if not $('#johndeere-pending').is(':visible')
            ]

        johnDeereNewSyncDataYield:
            [
                (data) ->
                    $('#johndeere-importing-yield').toggle('slide') if $('#johndeere-importing-yield').is(':visible')
                    $('#johndeere-pending-yield').toggle('slide') if not $('#johndeere-pending-yield').is(':visible')
            ]

        johnDeereNewSyncDataApplication:
            [
                (data) ->
                    $('#johndeere-importing-application').toggle('slide') if $('#johndeere-importing-application').is(':visible')
                    $('#johndeere-pending-application').toggle('slide') if not $('#johndeere-pending-application').is(':visible')
            ]

        johnDeereNewSyncDataPlanting:
            [
                (data) ->
                    $('#johndeere-importing-planting').toggle('slide') if $('#johndeere-importing-planting').is(':visible')
                    $('#johndeere-pending-planting').toggle('slide') if not $('#johndeere-pending-planting').is(':visible')
            ]

        updateConfirmationCount:
            [
                (data) ->
                    window.confirmation?(data)
            ]

        down:
            [
                (data) ->
                    $('.down-dialog').modal('show')
                    window.header?.disable()
            ]

        up:
            [
                (data) ->
                    $('.down-dialog').modal('hide')
                    window.header?.enable()
            ]

    constructor: () ->

        @onOpen = []

        # Release the kraken!
        @open()

        # Check every 5 seconds to see if the socket closed, and try to reopen
        setInterval () =>
            if not @socket
                @open()
        , 5000

    whenopen: (callback) =>
        if @socket?.readyState is 1
            callback()
        else
            @onOpen.push callback

    open: () =>
        hostname = window.location.host
        @socket = new SockJS "#{window.location.protocol}//#{hostname}/ws"

        # Send our user id for authorization
        @socket.onopen = () =>
            for callback in @onOpen
                callback()
            @onOpen = []

        # Handle messages sent to us
        @socket.onmessage = (e) =>
            json = $.parseJSON(e.data)

            for i, func of @messageHandlers[json.channel]
                debugLog 'Calling socket handler', json.channel, json.data, i, func
                func(json.data)

        @socket.onclose = () =>
            @socket = null


    reconnect: () =>
        if @socket?.readyState is SockJS.CONNECTING
            @socket.onopen = () =>
                @socket?.close()
        else
            # This is enough to cause the websocket to reconnect
            @socket?.close()


    register: (channel, handler) =>
        @messageHandlers[channel] = [] if not @messageHandlers[channel]

        idx = @messageHandlers[channel].push(handler) - 1
        debugLog 'registering', channel, idx

        return () =>
            debugLog 'unregistering', channel, idx
            delete @messageHandlers[channel][idx]
            return
